import type { Cin7Location, Cin7LocationBin } from "@/api/dtos";
import type { LocationAddress, LocationBin } from "@/api/location/_models/Location";

export const toLocationBinFromCin7LocationBin = (
  bin: Cin7LocationBin,
): LocationBin => {
  return {
    id: bin.ID,
    name: bin.Name,
    isDeprecated: bin.IsDeprecated,
    isStaging: bin.IsStaging,
  };
};

/** The flat Address* fields on a Cin7 location collapsed into one address object. */
export const toLocationAddressFromCin7Location = (
  dto: Cin7Location,
): LocationAddress => {
  return {
    line1: dto.AddressLine1,
    line2: dto.AddressLine2,
    citySuburb: dto.AddressCitySuburb,
    stateProvince: dto.AddressStateProvince,
    zipPostCode: dto.AddressZipPostCode,
    country: dto.AddressCountry,
  };
};
